(function ($) {
  supercatHeaderV1 = {
    formatter: $('.supercat-header-v1')
  };

  Drupal.behaviors.supercatHeaderV1 = {
    get: function (key) {
      return supercatHeaderV1[key];
    },

    set: function (key, val) {
      supercatHeaderV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        thisFormatter.find('.node-elc-nodeblock').removeClass('clearfix');

        var showOptin = thisFormatter.attr('data-show-emailoptin');

        if (typeof showOptin !== 'undefined' && showOptin !== false && showOptin !== '' && typeof site.optin !== 'undefined') {
          if (!site.optin.ui.userEmailOption) {
            site.optin.ui.optin_key = showOptin;
            site.optin.initOverlay();
          }
        }

        var link = thisFormatter.find('.button').attr('href');

        if (typeof link !== 'undefined') {
          thisFormatter.wrapInner('<a href="' + link + '" class="wrapper-link"></a>');
        }
      });
    }
  };
})(jQuery);
